import { view } from '@yola/ws-sdk';

const getLiveMapSource = (elementId) => {
  const element = view.accessors.getLiveElement(elementId);
  return element.src;
};

export default getLiveMapSource;
